import moment from 'moment';
import 'moment/locale/ru';
import { viewerModel } from 'entities/viewer';
import { notification } from 'antd';
import { useEffect } from 'react';
import { getRightDaysDeclension } from 'shared/helpers/endings';
import Routing from '../pages';
import { withHocs } from './providers';
import { useMeQuery } from './services/edpApiV1/viewer';
import { useAppSelector } from './store';
import './styles/fonts/Neotis.ttf';

import './index.scss';

/**
 * Entry-point приложения
 * @remark Содержит в HOC-обертке инициализирующую логику приложения
 * @see withHocs
 */

moment.locale('ru');

const App = () => {
  const isAuth = useAppSelector(viewerModel.credentials.selectors.getIsAuth);
  const { lastName, middleName, name } = useAppSelector(viewerModel.me.selectors.getViewerProfileInfo);
  const { data } = useMeQuery(null, { skip: !isAuth });
  const diff = moment(data?.expirationDate).diff(new Date(), 'd');
  useEffect(() => {
    if (data?.expirationDate && diff <= Number(data?.dayForAttention)) {
      notification.warning({
        message: `
        Уважаемый(ая) ${lastName} ${name} ${middleName}!
        Срок действия пароля от Вашей учетной записи для доступа к 
        веб-интерфейсу сотрудника HR-службы истекает через ${diff} ${getRightDaysDeclension(diff)}.`,
        style: {
          backgroundColor: 'rgb(246, 246, 143)',
        },
      });
    }
  }, [data]);
  return <Routing />;
};

export default withHocs(() => <App />);
